document.addEventListener("DOMContentLoaded", function () {
    function setupDropdown() {
        const menuItem = document.getElementById("ti-menu-item-with-dropdown");
        const dropdown = document.getElementById("ti-menu-dropdown");

        if (!menuItem || !dropdown) return;

        const arrowSpan = menuItem.querySelector("span");
        const dropdownParent = dropdown.parentElement;
        const dropdownNextSibling = dropdown.nextSibling;
        const productColorProperty = "--color-primary-on-surface";
        const originalProductColor = dropdown.style.getPropertyValue(productColorProperty);
        const originalProductColorPriority = dropdown.style.getPropertyPriority(productColorProperty);

        function placeDropdown() {
            const triggerRect = menuItem.getBoundingClientRect();
            const dropdownWidth = dropdown.offsetWidth || 225;
            const leftBoundary = 8;
            const rightBoundary = window.innerWidth - dropdownWidth - 8;
            const left = Math.max(leftBoundary, Math.min(triggerRect.left, rightBoundary));

            dropdown.style.position = "fixed";
            dropdown.style.left = `${left}px`;
            dropdown.style.top = `${triggerRect.bottom + 8}px`;
            dropdown.style.zIndex = "9999";
        }

        function handleViewportChange() {
            if (dropdown.classList.contains("block")) {
                placeDropdown();
            }
        }

        function setDropdownState(isOpen) {
            dropdown.classList.toggle("block", isOpen);
            dropdown.classList.toggle("hidden", !isOpen);
            menuItem.classList.toggle("text-neutral-on-primary", isOpen);
            menuItem.classList.toggle("text-neutral-subtle-on-primary", !isOpen);

            if (isOpen) {
                // Das Portal verliert beim Verschieben seinen Produktkontext.
                const productColor = getComputedStyle(dropdown).getPropertyValue(productColorProperty);
                dropdown.style.setProperty(productColorProperty, productColor);
                document.body.appendChild(dropdown);
                placeDropdown();
                window.addEventListener("resize", handleViewportChange);
                window.addEventListener("scroll", handleViewportChange, true);
            } else {
                window.removeEventListener("resize", handleViewportChange);
                window.removeEventListener("scroll", handleViewportChange, true);

                dropdown.style.position = "";
                dropdown.style.left = "";
                dropdown.style.top = "";
                dropdown.style.zIndex = "";

                if (dropdownParent) {
                    if (dropdownNextSibling && dropdownNextSibling.parentNode === dropdownParent) {
                        dropdownParent.insertBefore(dropdown, dropdownNextSibling);
                    } else {
                        dropdownParent.appendChild(dropdown);
                    }
                }
                if (originalProductColor) {
                    dropdown.style.setProperty(productColorProperty, originalProductColor, originalProductColorPriority);
                } else {
                    dropdown.style.removeProperty(productColorProperty);
                }
            }

            if (arrowSpan) {
                arrowSpan.style.transform = isOpen ? "rotate(180deg)" : "rotate(0deg)";
                arrowSpan.style.transition = "transform 0.3s ease";
            }
        }

        menuItem.addEventListener("click", function (event) {
            const shouldOpen = !dropdown.classList.contains("block");
            setDropdownState(shouldOpen);
            event.stopPropagation();
        });

        document.addEventListener("click", function (event) {
            if (!menuItem.contains(event.target) && !dropdown.contains(event.target)) {
                setDropdownState(false);
            }
        });
    }

    setupDropdown();
});
